import type * as React from "react";

type RootLayoutProps = {
  children: React.ReactNode;
};

export function RootLayout({ children }: RootLayoutProps) {
  return (
    <div className="relative min-h-dvh overscroll-none scroll-smooth whitespace-pre-line antialiased focus:scroll-auto">
      <a
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-50 focus:rounded-md focus:bg-background focus:px-4 focus:py-2 focus:text-foreground focus:ring-2 focus:ring-ring"
        href="#main-content"
      >
        Skip to content
      </a>
      {children}
    </div>
  );
}

const _getLayout = (page: React.ReactElement) => (
  <RootLayout>{page}</RootLayout>
);
